<div class="toggle-profile" [style.width.px]="size" [style.height.px]="size">

  <custom-avatar
  [id]="assignee?.ID"
    [name]="assignee?.getName()"
    [color]="assignee?.AVATAR_COLOR"
    [url]="assignee?.AVATAR_URL"
    [size]="size"></custom-avatar>
  
  <template #target></template>
</div>
